/**
 * EnergyRole - Role para conversão de unidades de energia
 *
 * Implementa os 4 pilares via SimpleRole base class.
 * Para uso funcional, prefira importar dos pilares diretamente.
 *
 * @example
 * // OOP style
 * import { energyRole } from '@attrx/role-morphic/energy';
 * energyRole.convert('kilocalorie', 'kilojoule', 1);  // 4.1868
 *
 * // Functional style (preferido)
 * import { convertEnergy } from '@attrx/role-morphic/energy/convert';
 * convertEnergy('kilocalorie', 'kilojoule', 1);  // 4.1868
 */

import { SimpleRole, type SimpleValidationConfig } from "../../contracts";
import { ENERGY_UNITS, ENERGY_ALIASES } from "./constants";

// =============================================================================
// ENERGY ROLE CLASS
// =============================================================================

export class EnergyRole extends SimpleRole {
  readonly name = "energy";
  readonly base = "joule";
  readonly units = ENERGY_UNITS;
  readonly aliases = ENERGY_ALIASES;

  readonly validation: SimpleValidationConfig = {
    min: 0,
    minError: "Energy cannot be negative",
  };
}

// =============================================================================
// SINGLETON INSTANCE
// =============================================================================

/** Instância singleton da EnergyRole */
export const energyRole = new EnergyRole();
